module.exports = __webpack_public_path__ + "media/images/sp/articles/recommend_02-0d4774feb9e00afb120376b5654a8730.webp";